export default "__VITE_ASSET__CwgFgJ_r__"